import { ENABLED_MARKET_GROUPS } from "AppStore";

function createLinkFromMarketMode(market, modeIndex) {
  const mode = market.modes[market.modes.length > modeIndex ? modeIndex : 0];
  return <a
      style={{textDecoration: 'underline'}}
      href={mode.path}
      target='_blank'
      rel='noreferrer'
    >
    {market.title}
  </a>;
}

export function getPlatformsByCategory(currentMarket) {
  const marketGroup = ENABLED_MARKET_GROUPS.find(group => 
    group.markets.some(market => market === currentMarket)
  );
  
  return marketGroup ? marketGroup.markets : [];
}

export function getOtherPlatformsFaqBlock(enabledPlatforms, market, modeIndex) {
  const otherPlatforms = enabledPlatforms.filter(m => m !== market);
  if (!otherPlatforms.length)
    return null;

  return {
    title: 'Какие платформы еще поддерживаются?',
    isH3: false,
    text:
      <div>
        {
          otherPlatforms.length === 1
            ? <>Boostclick также работает с {createLinkFromMarketMode(otherPlatforms[0], modeIndex)}</>
            : <>
                Boostclick также работает с:
                <br />
                <ul>
                  {
                    otherPlatforms.map(market =>
                      <li>{createLinkFromMarketMode(market, modeIndex)}</li>
                    )
                  }
                </ul>
              </>
        }
      </div>
  };
}
